import { flattenJsonApiResponse } from '@/store/utils/converter'
import { GetterNames } from './keys'
import { ShiftReportState, FlatShiftReport } from './types'

export const getters = {
  [GetterNames.shiftReport]: (state: ShiftReportState): FlatShiftReport[] => {
    return state.shiftReport.map(flattenJsonApiResponse)
  },
  [GetterNames.chosenDate]: (state: ShiftReportState): string => {
    return state.chosenDate
  },
  [GetterNames.chosenShiftPeriod]: (state: ShiftReportState): string => {
    return state.chosenShiftPeriod
  },
}
